import React from 'react';
import NewHeader from './Header';

const Header = ({ drawerOpen, drawerToggle, sidebarWidth }) => {
  return (
    <NewHeader 
      sidebarWidth={sidebarWidth} 
      drawerOpen={drawerOpen} 
      drawerToggle={drawerToggle} 
    />
  );
};

export default Header;
